import { render, staticRenderFns } from "./DateRange.vue?vue&type=template&id=97d37044&scoped=true&"
import script from "./DateRange.vue?vue&type=script&lang=js&"
export * from "./DateRange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97d37044",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('97d37044')) {
      api.createRecord('97d37044', component.options)
    } else {
      api.reload('97d37044', component.options)
    }
    module.hot.accept("./DateRange.vue?vue&type=template&id=97d37044&scoped=true&", function () {
      api.rerender('97d37044', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4zkgTx8Ll4nwo/JS/comp/DateRange.vue"
export default component.exports